import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';

import { TRootState } from '@/redux/rootReducer';
import { getUserFavorites } from '@/redux/selectors/favorites';
import { IRentalTile, mapRentalsToTiles } from '@/utility/mapSearchResultToTile';

type TSimilarRentalsData = TRootState['similarRentals']['data'];

const getSimilarRentalsList = createSelector(
  (state: TRootState) => state.similarRentals,
  data => data.data,
);

export const getSimilarRentalsFetched = createSelector(
  (state: TRootState) => state.similarRentals,
  (state: TRootState) => state.rentals,
  (similarRentals, rentals) => similarRentals.isFetched || rentals.isFetched,
);

export const getSimilarRentalsTiles = createSelector<
  TRootState,
  ReturnType<typeof getUserFavorites>,
  TSimilarRentalsData,
  TRootState['queryParams'],
  IRentalTile[]
>(
  getUserFavorites,
  state => {
    const similarRentalsList = getSimilarRentalsList(state);
    return isEmpty(similarRentalsList) ? getRentalsList(state) : similarRentalsList;
  },
  state => state.queryParams,
  (favorites, data, queryParams) => mapRentalsToTiles({ rentals: data, favorites, queryParams }),
);

const getRentalsList = createSelector(
  (state: TRootState) => state.rentals,
  data => data.rentals,
);

export const getRentalsFetched = createSelector(
  (state: TRootState) => state.rentals,
  rentals => rentals.isFetched,
);

export const getRentalsTiles = createSelector<
  TRootState,
  ReturnType<typeof getUserFavorites>,
  TSimilarRentalsData,
  TRootState['queryParams'],
  IRentalTile[]
>(
  getUserFavorites,
  getRentalsList,
  state => state.queryParams,
  (favorites, data, queryParams) => mapRentalsToTiles({ rentals: data, favorites, queryParams }),
);
